import styled from "styled-components";

import { Default } from "Types";

import AtomCircleNumber from "Components/Atoms/CircleNumber";
import AtomText from "Components/Atoms/Text";
import { typography } from "globalConstants";

export type PropsType = any;

const Wrap = styled.div<Default>`
   display: flex;
   flex-direction: column;
   align-items: center;
   row-gap: 12px;
   ${({ css }) => css}
`;

const StyleAtomText = styled(AtomText)`
   text-align: center;
   width: 10px;
   white-space: nowrap;
   display: flex;
   justify-content: center;
   color: ${typography.other.color.gray[1]};
   ${({ css }) => css}
`;

export default function Dot(props: PropsType) {
   return (
      <Wrap {...props}>
         <AtomCircleNumber css={props.cssNumber}>{props.number}</AtomCircleNumber>
         <StyleAtomText t={"t7"} css={props.cssText}>
            {props.text}
         </StyleAtomText>
      </Wrap>
   );
}
